import { PfTypeahead } from '@lidea/search/shared/ui-pf-typeahead';
import { ModalPage } from '@lidea/shared/ui/layout';

import modalStyles from '../lidea-ion-modal.module.css';

import type { PfSelectOption } from './pf-select.types';

export interface PfSelectPickerModalProps {
  title?: string;
  options: PfSelectOption[];
  selectedValue?: string;
  onPick?: (value: string) => void;
  dismiss: () => void;
}

export function PfSelectPickerModal({
  title = '',
  options,
  selectedValue,
  onPick,
  dismiss,
}: PfSelectPickerModalProps) {
  return (
    <ModalPage title={title} onClose={dismiss}>
      <div className={modalStyles.modalBodyTypeahead}>
        <PfTypeahead
          items={options}
          mode="single"
          selectedItems={selectedValue ? [selectedValue] : []}
          onSelectionChange={(items) => {
            const next = items[0];
            if (next) {
              onPick?.(next);
            }
            dismiss();
          }}
        />
      </div>
    </ModalPage>
  );
}
